// download app dialog
export const DOWNLOAD_APP_DIALOG_TEXT = 'download.app.dialog.text';
export const DOWNLOAD_APP_DIALOG_BUTTON_TEXT = 'download.app.dialog.button.text';
